import * as angular from 'angular';
import { PagingResultPhysicalProductSearchInStore } from '../../../../app.jisppay/modules/core';

interface IAutocompleteScope {
    ngProductSearchGetData: (search?: any) => ng.IPromise<PagingResultPhysicalProductSearchInStore>;
    ngProductSearchGetProductImage: (imageID: number) => string;
    ngProductSearchItemAddAction: (item: any, $event: Event) => void;
    ngProductSearchItemDeleteAction: (item: any, $event: Event) => void;
    ngProductSearchItemRestoreAction: (item: any, $event: Event) => void;
    ngProductSearchItemClick: (item: any, $event?: Event) => void;
    clear: () => void;
    ngProductSearchItemTemplate: any;
    ngProductSearchKeyPressDelay: string;
    waiting: boolean;
    showOverlay: boolean;
    values: Array<any>;
    ngProductSearch: any;
    ngReadonly: boolean;
    ngActionsAllowed: boolean;
    ngModel: string;
    country: number;
}

function ngProductSearch($templateCache: any, $compile: any, $timeout: any): ng.IDirective {
    return {
        require: 'ngModel',
        restrict: 'A',
        scope: {
            ngProductSearchGetData: '&',
            ngProductSearchGetProductImage: '&',
            ngProductSearchItemAddAction: '&?',
            ngProductSearchItemRestoreAction: '&?',
            ngProductSearchItemDeleteAction: '&?',
            ngProductSearchItemClick: '&',
            ngProductSearchItemTemplate : '@',
            ngProductSearchKeyPressDelay : '@',
            ngProductSearch: '=',
            ngReadonly: '=',
            ngActionsAllowed: '=',
            ngModel: '=',
            country: '='
        },
        link: function (scope: ng.IScope & IAutocompleteScope, element: JQLite, attr: ng.IAttributes, ctrl: ng.IController) {
            var itemTemplate = $templateCache.get(scope.ngProductSearchItemTemplate);
            var listDomElement: HTMLElement;
            var overlay: HTMLElement;
            var currentPage = 1;
            var searchTerm: string;
            var nothingToLoad = false;
            var previousTimeStamp = 0;
            var keyPressDelay = scope.ngProductSearchKeyPressDelay ? parseInt(scope.ngProductSearchKeyPressDelay, 10) : 500;

            scope.clear = () => {
                scope.ngModel = '';
            };

            element.bind('input propertychange paste', function(event: Event) {
                showBorders();
                var inputValue = <string>(this.value).trim();
                searchTerm = inputValue;
                let value = inputValue;
                previousTimeStamp = event.timeStamp;

                clear();

                if (!value) {
                    scope.showOverlay = false;
                    hideBorders();
                    return;
                }
                scope.showOverlay = true;
                $timeout(() => {
                    if (!listDomElement) {
                        listDomElement = document.createElement('DIV');
                        listDomElement.setAttribute('id', this.id + 'ng-product-search-list');
                        listDomElement.setAttribute('class', 'ng-product-search-items product-search__list');

                        var overlayTemplate = '<div class="searchInput-backdrop" ng-click="clear()" ng-show="ngModel.length>0"></div>';
                        overlay = $compile(overlayTemplate)(scope)[0];

                        this.parentNode.parentNode.appendChild(overlay);

                        this.parentNode.parentNode.appendChild(listDomElement);
                        var itemListTemplate = '\
                            <div class="search-list__item" ng-repeat="value in values" ng-click="ngProductSearchItemClick({item: value, $event: $event})">' + itemTemplate +
                             '</div><div class="absolute-center-flex" ng-show="waiting"><img class="rotate-animation mt16 mb16" src="/assets/images/blue-loader.svg"></div>';
                        listDomElement.appendChild($compile(itemListTemplate)(scope)[0]); // append list
                        listDomElement.appendChild($compile(itemListTemplate)(scope)[1]); // append h1 aka loader

                        listDomElement.onscroll = () => {
                            if (listDomElement.scrollHeight === (listDomElement.scrollTop + listDomElement.clientHeight)) { // if scrolled to bottom
                                if (scope.waiting || nothingToLoad) {
                                    return;
                                }
                                scope.waiting = true; // show "loading" while calling API
                                scope.ngProductSearchGetData({search: searchTerm, page: currentPage}).then((data: PagingResultPhysicalProductSearchInStore) => {
                                    if (this.value !== searchTerm) { // if search term had been changed after API call (on scroll to bottom)
                                        return;
                                    }
                                    scope.waiting = false;
                                    if (data.Items.length === 0) {
                                        nothingToLoad = true; // Not to call API on next scroll to bottom
                                        return;
                                    }
                                    scope.values = scope.values.concat(data.Items);
                                    currentPage++;
                                });
                            }
                        };
                    }
                    ($('.product-search__list') as any).mCustomScrollbar({
                        axis: 'y',
                        theme: 'minimal-dark'
                    });
                }, 0);

                scope.waiting = true;
                $timeout(() => {
                    if (event.timeStamp === previousTimeStamp) {
                        scope.ngProductSearchGetData({search: value, page: currentPage}).then((data: PagingResultPhysicalProductSearchInStore) => {
                            if (value !== searchTerm) {
                                return;
                            }
                            if (data.Items.length === 0) {
                                hideBorders();
                            }
                            scope.waiting = false;
                            scope.values = data.Items;
                            currentPage++;
                        });
                    }
                }, keyPressDelay);
            });

            scope.$watch('ngModel', function() {
                if (element.val().trim() === '') {
                    clear();
                }
            });

            element.bind('focusout', function(e: any) {
                // nothing
            });
            element.bind('blur', function(e: any) {
                // nothing
            });

            function clear() {
                currentPage = 1;
                nothingToLoad = false;
                scope.waiting = false;
                scope.values = [];
            }

            function hideBorders() {
                if (listDomElement) {
                    listDomElement.classList.add('ng-product-search-items-no-borders');
                    // overlay.classList.remove('searchInput-backdrop');
                }
            }
            function showBorders() {
                if (listDomElement) {
                    listDomElement.classList.remove('ng-product-search-items-no-borders');
                    // overlay.classList.add('searchInput-backdrop');
                }
            }
        }
    };
}

angular
    .module('app.common')
    .directive('ngProductSearch', ngProductSearch);



// WEBPACK FOOTER //
// ./src/app.common/modules/common/directives/product-search.directive.ts